import { render, staticRenderFns } from "./ruleMgr.vue?vue&type=template&id=6b017fa8&"
import script from "./ruleMgr.vue?vue&type=script&lang=js&"
export * from "./ruleMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports